import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface INamePropertyEditable {
  name(): IPropertyEditable<string>;
}

export function instanceOfINamePropertyEditable(instance: any): instance is INamePropertyEditable {
  return instance
      && instance.name
      && instanceOfIPropertyEditable<string>(instance.name());
}
